import { WeaTools } from 'ecCom'

export const getSearchCondition = ( params ) => {
  return WeaTools.callApi('/api/hrm/group/getSearchCondition', 'GET', params);
}

export const save = ( params ) => {
  return WeaTools.callApi('/api/hrm/group/save', 'POST', params);
}

export const deleteTableRow = ( params ) => {
  return WeaTools.callApi('/api/hrm/group/delete', 'POST', params);
}

export const getSearchResult = ( params ) => {
  return WeaTools.callApi('/api/hrm/group/getSearchResult', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/addgroup.js